import { createTheme } from '@mui/material/styles';

const appTheme = createTheme({
  drawerWidth: 276,
  typography: {
    fontFamily: 'Montserrat, sans-serif',
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 16,
        },
      },
    },
  },
});

export type AppTheme = typeof appTheme;

export default appTheme;
